import { useState, useMemo } from "react";
import useLocalStorage from "../../../hooks/useLocalStorage";

export function useScreenLayoutInfo(device) {
  const storageKey = `screenLayoutInfo_${device}`;

  // 1. Persistent State
  const [persistentState, setPersistentState] = useLocalStorage(storageKey, {
    showGrid: true,
    screenMode: "editable",
    scaleFactor: 1,
    gridSize: device === "desktop" ? 8 : 4
  });

  // 2. Ephemeral State
  const [ephemeralState, setEphemeralState] = useState({
    showTree: false,
    showTemplate: false
  });

  // 3. Merge states
  const screenLayoutInfo = useMemo(
    () => ({ ...persistentState, ...ephemeralState }),
    [persistentState, ephemeralState]
  );

  // 4. Custom Setter Logic
  const setScreenLayoutInfo = (valueOrFn) => {
    const currentFullState = { ...persistentState, ...ephemeralState };
    const nextFullState = typeof valueOrFn === "function" ? valueOrFn(currentFullState) : valueOrFn;

    if (nextFullState.screenMode === "view") {
      nextFullState.showGrid = false;
      nextFullState.showTemplate = false;
      nextFullState.showTree = false;
    }

    setPersistentState((prev) => ({
      ...prev,
      showGrid: nextFullState.showGrid,
      screenMode: nextFullState.screenMode,
      scaleFactor: nextFullState.scaleFactor,
      gridSize: nextFullState.gridSize
    }));

    setEphemeralState((prev) => ({
      ...prev,
      showTree: nextFullState.showTree,
      showTemplate: nextFullState.showTemplate
    }));
  };

  // Return as array like [state, setState]
  return [screenLayoutInfo, setScreenLayoutInfo];
}
